var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailbox = function SvgMailbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 190 191"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#6830F7",
    clipPath: "url(#mailbox_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.433 54.769h-9.085v72.378h9.085zM167.348 45.744h-9.025v9.025h9.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.592 136.231h54.269V190.5h9.084v-54.269h27.135V190.5h9.025v-54.269h45.243v-9.084H85.945V54.769h-9.084v-9.025h36.219v27.134h9.025V45.744h36.218v-9.085h-36.218v-9.025h27.134V.5H113.08v36.16H31.617v9.084h-9.025v9.025h-9.025v72.378h9.025zM122.105 9.525h18.109v9.084h-18.109zM22.592 63.794h9.025v-9.025h18.11v9.025h-18.11v45.244h-9.025z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mailbox_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h190v190H0z"
  })))));
};
export default SvgMailbox;